import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Page from '../../../componentes/plantilla/Page';
import Card from '../../../componentes/contenedores/Card';
import { useContextUsuario } from '../../../contexto/usuario/UsuarioContext';
import { DashboardServicio } from '../../../servicios/dashboardServicio';
import Barras from '../../../componentes/graficos/Barras';

const InicioEmpleados = () => {
  const { usuario } = useContextUsuario();
  const navigate = useNavigate();

  // Empleado ID activo en sesión o seleccionado para demo
  const idUsuarioActual = usuario?.datoPersonales?.id || usuario?.id || 9;
  const [empleadoSeleccionadoId, setEmpleadoSeleccionadoId] = useState(idUsuarioActual);

  // Sincronizar automáticamente cuando el usuario termine de cargarse desde el contexto
  useEffect(() => {
    const idSesion = usuario?.datoPersonales?.id || usuario?.id;
    if (idSesion) {
      setEmpleadoSeleccionadoId(idSesion);
    }
  }, [usuario]);

  const [resumen, setResumen] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [origenDatos, setOrigenDatos] = useState('');

  const datosPage = {
    titulo: {
      titulo: 'Dashboard Operativo',
      url: '/app/admin/empleados/',
      tituloUrl: 'Menú Principal',
      nombreUrl: 'Inicio',
    },
  };

  const cargarDashboard = async (empId = empleadoSeleccionadoId) => {
    try {
      setCargando(true);
      const res = await DashboardServicio.obtenerResumenEmpleado(empId);
      setResumen(res.datos);
      setOrigenDatos(res.origen);
    } catch (error) {
      console.error('Error cargando dashboard operativo:', error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarDashboard(empleadoSeleccionadoId);
  }, [empleadoSeleccionadoId]);

  const formatLempiras = (val) =>
    `L ${Number(val || 0).toLocaleString('es-HN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const idSesionActual = usuario?.datoPersonales?.id || usuario?.id;
  const esSesionActiva = empleadoSeleccionadoId === idSesionActual;
  const nombreUsuario =
    esSesionActiva && usuario?.datoPersonales
      ? `${usuario.datoPersonales.primerNombre || ''} ${usuario.datoPersonales.primerApellido || ''}`.trim() || usuario.datoPersonales.nombreCompleto
      : (resumen?.empleado?.nombreCompleto || 'Colaborador');

  const cargoUsuario = resumen?.empleado?.cargo || 'Asesor Comercial / Ventas';

  // Datos para el gráfico de barras de pedidos
  const datosGraficoPedidos = {
    labels: ['Pendientes', 'Programadas', 'En Ruta', 'Para Hoy'],
    data: [
      resumen?.pedidosAsignados?.totalPendientes || 0,
      resumen?.pedidosAsignados?.totalProgramadas || 0,
      resumen?.pedidosAsignados?.totalEnRuta || 0,
      resumen?.pedidosAsignados?.totalHoy || 0,
    ],
    colors: ['#f59e0b', '#3b82f6', '#10b981', '#1467cd'],
    mostrarTitulo: false,
    mostrarLeyenda: false,
  };

  return (
    <Page datos={datosPage}>
      {/* 1. Encabezado de Bienvenida y Acciones Rápidas */}
      <div className="card shadow-sm mb-4">
        <div className="card-body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div>
              <div className="d-flex align-items-center gap-2 mb-1">
                <span className="badge badge-primary px-2 py-1 font-weight-normal">
                  <i className="fas fa-user-circle mr-1"></i> {cargoUsuario}
                </span>
                <span
                  className={`badge px-2 py-1 ${
                    origenDatos === 'API_REAL' ? 'badge-success' : 'badge-info'
                  }`}
                  title="Estado del servicio backend"
                >
                  <i className={`fas ${origenDatos === 'API_REAL' ? 'fa-link' : 'fa-magic'} mr-1`}></i>
                  {origenDatos === 'API_REAL' ? 'Conectado a API Backend' : 'Prototipo Operativo Activo'}
                </span>
              </div>
              <h2 className="font-weight-bold my-1" style={{ fontSize: '1.75rem' }}>
                ¡Hola de nuevo, {nombreUsuario}! 👋
              </h2>
              <p className="text-muted mb-0 small">
                Resumen de tus pedidos asignados, ventas del día, cotizaciones en seguimiento y cartera de clientes.
              </p>
            </div>

            {/* Selector de Presets / Demostración y Botones Rápidos */}
            <div className="d-flex flex-column align-items-end gap-2">
              <div className="d-flex align-items-center gap-2">
                <label className="small text-muted mb-0 font-weight-bold d-none d-sm-inline">
                  Vista Operativa:
                </label>
                <select
                  className="form-control form-control-sm border-primary"
                  style={{ width: '220px' }}
                  value={empleadoSeleccionadoId}
                  onChange={(e) => setEmpleadoSeleccionadoId(Number(e.target.value))}
                >
                  <option value={idUsuarioActual}>Mi Usuario en Sesión</option>
                  <option value={9}>Alberto Amador (Vendedor Senior)</option>
                  <option value={10}>Carlos Meza (Vendedor Mayorista)</option>
                </select>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => cargarDashboard(empleadoSeleccionadoId)}
                  title="Recargar Métricas"
                >
                  <i className="fas fa-sync-alt"></i>
                </button>
              </div>

              {/* Botones de Acción Inmediata */}
              <div className="d-flex flex-wrap gap-2 mt-2">
                <Link to="/app/admin/pedidos/nuevo" className="btn btn-sm btn-primary shadow-sm font-weight-bold">
                  <i className="fas fa-plus-circle mr-1"></i> Nuevo Pedido
                </Link>
                <Link to="/app/admin/cotizaciones/nuevo" className="btn btn-sm btn-outline-primary shadow-sm">
                  <i className="fas fa-file-invoice mr-1"></i> Nueva Cotización
                </Link>
                <Link to="/app/admin/ventas/nuevo" className="btn btn-sm btn-outline-success shadow-sm">
                  <i className="fas fa-cash-register mr-1"></i> Registrar Venta
                </Link>
                <Link to="/app/admin/planillas" className="btn btn-sm btn-outline-secondary shadow-sm">
                  <i className="fas fa-money-check-alt mr-1"></i> Nómina
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {cargando ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="text-muted mt-2">Cargando tablero operativo...</p>
        </div>
      ) : (
        <>
          {/* 2. Tarjetas de Métricas Operativas (KPIs) */}
          <div className="row mb-4">
            {/* KPI 1: Pedidos Pendientes Asignados */}
            <div className="col-xl-3 col-md-6 mb-3">
              <div className="card h-100 shadow-sm border-left border-primary" style={{ borderLeftWidth: '5px !important' }}>
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <span className="text-muted text-uppercase small font-weight-bold">
                        Pedidos Asignados
                      </span>
                      <h3 className="font-weight-bold my-1">
                        {resumen?.pedidosAsignados?.totalPendientes || 0}
                      </h3>
                      <small className="text-primary font-weight-bold">
                        {resumen?.pedidosAsignados?.totalProgramadas || 0} Programadas • {resumen?.pedidosAsignados?.totalEnRuta || 0} En Ruta
                      </small>
                    </div>
                    <div className="text-primary p-3 rounded-circle" style={{ backgroundColor: 'rgba(20, 103, 205, 0.15)' }}>
                      <i className="fas fa-truck-loading" style={{ fontSize: '1.6rem' }}></i>
                    </div>
                  </div>
                  <div className="mt-3 pt-2 border-top d-flex justify-content-between align-items-center">
                    <span className="small text-muted">
                      {resumen?.pedidosAsignados?.totalHoy || 0} entregas para hoy
                    </span>
                    <Link to="/app/admin/pedidos/gestionar" className="small font-weight-bold text-primary">
                      Gestionar <i className="fas fa-chevron-right ml-1"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* KPI 2: Cotizaciones del Mes */}
            <div className="col-xl-3 col-md-6 mb-3">
              <div className="card h-100 shadow-sm border-left border-info" style={{ borderLeftWidth: '5px !important' }}>
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <span className="text-muted text-uppercase small font-weight-bold">
                        Cotizaciones del Mes
                      </span>
                      <h3 className="font-weight-bold my-1">
                        {resumen?.cotizaciones?.mesActualConteo || 0}
                      </h3>
                      <small className="text-info font-weight-bold">
                        {formatLempiras(resumen?.cotizaciones?.mesActualMonto)}
                      </small>
                    </div>
                    <div className="text-info p-3 rounded-circle" style={{ backgroundColor: 'rgba(74, 163, 221, 0.15)' }}>
                      <i className="fas fa-file-invoice-dollar" style={{ fontSize: '1.6rem' }}></i>
                    </div>
                  </div>
                  <div className="mt-3 pt-2 border-top d-flex justify-content-between align-items-center">
                    <span className="small text-warning font-weight-bold">
                      <i className="fas fa-clock mr-1"></i> {resumen?.cotizaciones?.pendientesAprobacion || 0} por cerrar
                    </span>
                    <Link to="/app/admin/cotizaciones/gestionar" className="small font-weight-bold text-info">
                      Ver todas <i className="fas fa-chevron-right ml-1"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* KPI 3: Mis Ventas de Hoy */}
            <div className="col-xl-3 col-md-6 mb-3">
              <div className="card h-100 shadow-sm border-left border-success" style={{ borderLeftWidth: '5px !important' }}>
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <span className="text-muted text-uppercase small font-weight-bold">
                        Mis Ventas de Hoy
                      </span>
                      <h3 className="font-weight-bold text-success my-1">
                        {formatLempiras(resumen?.ventas?.hoy?.totalMonto)}
                      </h3>
                      <small className="text-muted font-weight-bold">
                        {resumen?.ventas?.hoy?.conteo || 0} transacciones cerradas
                      </small>
                    </div>
                    <div className="text-success p-3 rounded-circle" style={{ backgroundColor: 'rgba(63, 185, 127, 0.15)' }}>
                      <i className="fas fa-cash-register" style={{ fontSize: '1.6rem' }}></i>
                    </div>
                  </div>
                  <div className="mt-3 pt-2 border-top d-flex justify-content-between align-items-center small text-muted">
                    <span>Contado: <strong>{formatLempiras(resumen?.ventas?.hoy?.contado)}</strong></span>
                    <span>Crédito: <strong>{formatLempiras(resumen?.ventas?.hoy?.credito)}</strong></span>
                  </div>
                </div>
              </div>
            </div>

            {/* KPI 4: Cartera y Clientes en Mora */}
            <div className="col-xl-3 col-md-6 mb-3">
              <div className="card h-100 shadow-sm border-left border-danger" style={{ borderLeftWidth: '5px !important' }}>
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <span className="text-muted text-uppercase small font-weight-bold">
                        Cartera en Mora Asignada
                      </span>
                      <h3 className="font-weight-bold text-danger my-1">
                        {formatLempiras(resumen?.carteraCreditos?.saldoMora)}
                      </h3>
                      <small className="text-danger font-weight-bold">
                        <i className="fas fa-exclamation-triangle mr-1"></i>
                        {resumen?.carteraCreditos?.clientesEnMoraConteo || 0} clientes vencidos
                      </small>
                    </div>
                    <div className="text-danger p-3 rounded-circle" style={{ backgroundColor: 'rgba(240, 96, 77, 0.15)' }}>
                      <i className="fas fa-user-clock" style={{ fontSize: '1.6rem' }}></i>
                    </div>
                  </div>
                  <div className="mt-3 pt-2 border-top d-flex justify-content-between align-items-center">
                    <span className="small text-muted">
                      Cartera total: {formatLempiras(resumen?.carteraCreditos?.saldoTotalPendiente)}
                    </span>
                    <Link to="/app/admin/ventas/credito" className="small font-weight-bold text-danger">
                      Cobranza <i className="fas fa-chevron-right ml-1"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 3. Panel de Progreso de Meta de Ventas del Mes */}
          {resumen?.ventas?.mesActual && (
            <div className="card shadow-sm mb-4">
              <div className="card-body p-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
                  <div>
                    <span className="font-weight-bold">
                      <i className="fas fa-chart-line text-primary mr-2"></i>
                      Progreso Acumulado de Ventas del Mes
                    </span>
                    <span className="text-muted small ml-2">
                      ({resumen.ventas.mesActual.conteo} facturas emitidas en el mes)
                    </span>
                  </div>
                  <div className="font-weight-bold">
                    <span className="text-primary h5 my-0">
                      {formatLempiras(resumen.ventas.mesActual.totalMonto)}
                    </span>
                    {resumen.ventas.mesActual.metaMes && (
                      <span className="text-muted small ml-1">
                        / Meta: {formatLempiras(resumen.ventas.mesActual.metaMes)} ({resumen.ventas.mesActual.porcentajeMeta}%)
                      </span>
                    )}
                  </div>
                </div>
                <div className="progress" style={{ height: '10px' }}>
                  <div
                    className="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: `${Math.min(resumen.ventas.mesActual.porcentajeMeta || 85, 100)}%` }}
                    aria-valuenow={resumen.ventas.mesActual.porcentajeMeta || 85}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
            </div>
          )}

          {/* 4. Tablas Operativas Principales a 2 Columnas */}
          <div className="row">
            {/* Columna Izquierda: Pedidos Pendientes de Atención (8 Columnas) */}
            <div className="col-lg-8 mb-4">
              <Card
                titulo="Mis Pedidos Pendientes de Atención"
                subtitulo="Pedidos programados o en ruta asignados para entrega y despacho."
                pie={
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <small className="text-muted">
                      Total asignados: {resumen?.pedidosAsignados?.items?.length || 0} pedidos en gestión
                    </small>
                    <Link to="/app/admin/pedidos/gestionar" className="btn btn-sm btn-primary">
                      Ver Todos los Pedidos
                    </Link>
                  </div>
                }
              >
                {resumen?.pedidosAsignados?.items?.length === 0 ? (
                  <div className="text-center py-4 border rounded">
                    <i className="fas fa-check-circle text-success" style={{ fontSize: '2.5rem' }}></i>
                    <h6 className="mt-2 font-weight-bold">¡Estás al día!</h6>
                    <p className="text-muted small mb-0">No tienes pedidos pendientes de entrega en este momento.</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0" style={{ fontSize: '0.9rem' }}>
                      <thead>
                        <tr>
                          <th>Pedido</th>
                          <th>Cliente / Dirección</th>
                          <th>Programación</th>
                          <th className="text-right">Total</th>
                          <th className="text-center">Estado</th>
                          <th className="text-center">Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {resumen?.pedidosAsignados?.items?.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <span className="font-weight-bold font-monospace">
                                #{item.id}
                              </span>
                            </td>
                            <td>
                              <div className="font-weight-bold">{item.cliente}</div>
                              <small className="text-muted d-block text-truncate" style={{ maxWidth: '250px' }}>
                                <i className="fas fa-map-marker-alt text-danger mr-1"></i>
                                {item.direccion}
                              </small>
                            </td>
                            <td>
                              <div className="small font-weight-bold">
                                <i className="fas fa-calendar-day mr-1 text-primary"></i>
                                {item.fecha}
                              </div>
                              <small className="text-muted">{item.hora}</small>
                            </td>
                            <td className="text-right font-weight-bold">
                              {formatLempiras(item.total)}
                            </td>
                            <td className="text-center">
                              <span
                                className={`badge px-2 py-1 ${
                                  item.estado === 'En Ruta'
                                    ? 'badge-success'
                                    : item.estado === 'Programada'
                                    ? 'badge-primary'
                                    : 'badge-warning'
                                }`}
                              >
                                {item.estado}
                              </span>
                            </td>
                            <td className="text-center">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => navigate('/app/admin/pedidos/gestionar')}
                                title="Ver detalle del pedido"
                              >
                                <i className="fas fa-external-link-alt"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </Card>

              {/* Gráfico de distribución de pedidos */}
              <div className="mt-4">
                <Card titulo="Distribución de Pedidos Asignados">
                  <div style={{ height: '260px', position: 'relative' }}>
                    <Barras datos={datosGraficoPedidos} esMonetario={false} altura="100%" />
                  </div>
                </Card>
              </div>
            </div>

            {/* Columna Derecha: Clientes en Mora & Cotizaciones en Negociación (4 Columnas) */}
            <div className="col-lg-4 mb-4">
              {/* Tarjeta de Clientes en Mora Asignados */}
              <Card
                titulo="Clientes en Mora Asignados"
                subtitulo="Cuentas por cobrar con fecha de vencimiento superada."
              >
                {resumen?.carteraCreditos?.clientesMora?.length === 0 ? (
                  <div className="text-center py-4 border rounded">
                    <i className="fas fa-shield-alt text-success" style={{ fontSize: '2rem' }}></i>
                    <p className="text-muted small mt-2 mb-0">¡Excelente! Ningún cliente asignado se encuentra en mora.</p>
                  </div>
                ) : (
                  <div className="d-flex flex-column gap-3">
                    {resumen?.carteraCreditos?.clientesMora?.map((mora, idx) => (
                      <div key={idx} className="p-3 border rounded shadow-sm">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <strong className="small text-truncate" style={{ maxWidth: '170px' }}>
                            {mora.nombre}
                          </strong>
                          <span className="badge badge-danger">
                            {mora.diasAtraso} días mora
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                          <div>
                            <span className="text-muted d-block" style={{ fontSize: '0.75rem' }}>
                              Saldo Vencido:
                            </span>
                            <span className="font-weight-bold text-danger">
                              {formatLempiras(mora.saldoVencido)}
                            </span>
                          </div>
                          {mora.telefono && (
                            <a
                              href={`tel:${mora.telefono}`}
                              className="btn btn-sm btn-outline-secondary"
                              title={`Llamar a ${mora.telefono}`}
                            >
                              <i className="fas fa-phone-alt text-primary"></i>
                            </a>
                          )}
                        </div>
                      </div>
                    ))}
                    <Link to="/app/admin/ventas/credito" className="btn btn-sm btn-outline-danger btn-block mt-2">
                      <i className="fas fa-hand-holding-usd mr-1"></i> Ir a Gestión de Créditos
                    </Link>
                  </div>
                )}
              </Card>

              {/* Tarjeta de Cotizaciones Recientes */}
              <div className="mt-4">
                <Card titulo="Cotizaciones en Seguimiento">
                  {resumen?.cotizaciones?.ultimasCotizaciones?.length > 0 ? (
                    <div className="list-group list-group-flush">
                      {resumen.cotizaciones.ultimasCotizaciones.map((cot) => (
                        <div key={cot.id} className="list-group-item px-0 py-2 d-flex justify-content-between align-items-center">
                          <div>
                            <div className="font-weight-bold small">{cot.cliente}</div>
                            <small className="text-muted">Cot. #{cot.id} • {cot.fecha}</small>
                          </div>
                          <div className="text-right">
                            <span className="font-weight-bold d-block small">
                              {formatLempiras(cot.monto)}
                            </span>
                            <span className={`badge ${cot.estado === 'Aprobada' ? 'badge-success' : 'badge-warning'}`} style={{ fontSize: '0.7rem' }}>
                              {cot.estado}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-muted small text-center py-3 mb-0">No hay cotizaciones pendientes registradas.</p>
                  )}
                  <Link to="/app/admin/cotizaciones/gestionar" className="btn btn-sm btn-outline-primary border btn-block mt-3">
                    Ver Cartera de Cotizaciones
                  </Link>
                </Card>
              </div>
            </div>
          </div>
        </>
      )}
    </Page>
  );
};

export default InicioEmpleados;
